export { ModalAlterarSetor } from './modal-alterar-setor'
export * from './tipos'
